// @flow

import type { IncomingPayment } from '@tectonics/prs/incoming-payment';
import type { UserInputValues } from '@tectonics/prs/user-input-values';
import type { CheckoutReceipts } from '@tectonics/prs/receipts/types';
import { fetchInstalmentsPlan } from './fetch-instalments-plan';

export async function fetchCustomReceipts(
  incomingPayment: IncomingPayment,
  userInputValues: UserInputValues,
): Promise<?CheckoutReceipts> {
  const { checkout_receipts } = incomingPayment;

  if(!checkout_receipts) {
    return checkout_receipts;
  }

  const currentInstalments = checkout_receipts.instalments;
  const instalments = await fetchInstalmentsPlan(incomingPayment, userInputValues);

  return {
    ...checkout_receipts,
    instalments: Object.keys(instalments).length > 0 ? instalments : currentInstalments,
  };
}
